import { render, staticRenderFns } from "./CardFloat2.vue?vue&type=template&id=12346bcd&scoped=true"
import script from "./CardFloat2.vue?vue&type=script&lang=js"
export * from "./CardFloat2.vue?vue&type=script&lang=js"
import style0 from "./CardFloat2.vue?vue&type=style&index=0&id=12346bcd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12346bcd",
  null
  
)

export default component.exports